export enum SettingsTabValue {
  main = "main",
  "kyc-kyb" = "kyc-kyb",
  requisites = "requisites",
}
